import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function Driverpavati() {
    const location = useLocation();
    const { driverInfo, schoolDetails, selectedYear, roots,combinedRootData } = location.state || {};
// console.log("roots",roots);

    const navigate = useNavigate();
    const [fromtheway, setFromtheway] = useState('');
    const [thewayup, setThewayup] = useState('');
    const [feeDetails, setFeeDetails] = useState([]);
    const [serialNos, setSerialNos] = useState([]);
    const [amount, setAmount] = useState('');
    const [serialNofinal, setSerialNofinal] = useState('');
    const [studentDataMap, setStudentDataMap] = useState({});
    const [actualFee, setActualFee] = useState('');
    const [rootData, setRootData] = useState({ studentSerialNo: [] });
    const udiseNumber = localStorage.getItem("udiseNumber");
// console.log("combinedRootData",combinedRootData);
const [studentFeeDataMap, setStudentFeeDataMap] = useState({});

    const language = localStorage.getItem("language");
    const fetchRootDetails = () => {
      const rootData = combinedRootData;
      const studentSerialNo = rootData.studentSerialNo || {};
      // console.log("rootData", rootData);
  
      setFromtheway(rootData.fromtheway || '');
      setThewayup(rootData.thewayup || '');
  
      // Collect serial numbers that are marked true in studentSerialNo
      const serialNumbers = Object.keys(studentSerialNo).filter(serial => studentSerialNo[serial]);
      setSerialNos(serialNumbers);
  };

  const fetchFeeDetails = async (serialNo) => {
    try {
        const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${selectedYear}.json`;
        const response = await fetch(feeUrl);
        const rootData = await response.json();

        let studentRoot = '';
        let fromtheway = '';
        let thewayup = '';
        let feeAmount = 0; // Store the fee amount for the student

        // Log rootData to see if it contains the necessary data
        // console.log("Root Data:", rootData);

        // Iterate through each root to find the corresponding root and fee for the serial number
        for (const rootKey in rootData) {
            const root = rootData[rootKey];
            if (root.studentSerialNo && root.studentSerialNo[serialNo] === true) {
                studentRoot = rootKey; // root1, root2, etc.
                fromtheway = root.fromtheway; // Assign fromtheway value
                thewayup = root.thewayup; // Assign thewayup value
                feeAmount = parseFloat(root.amount1) || 0; // Convert amount1 to a number
                break;
            }
        }

        // console.log(`Serial No: ${serialNo}, Fee Amount: ${feeAmount}`);

        // Return fee details along with root and way information
        return { root: studentRoot, fromtheway, thewayup, feeAmount };
    } catch (error) {
        console.error(`Error fetching fee details for ${serialNo}:`, error);
        return null;
    }
};



    const fetchStudentDetails = async () => {
        try {
            const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
            const response = await fetch(studentUrl);
            const studentData = await response.json();
            // console.log("studentData:", studentData);

            const studentMap = {};
            for (const serialNo in studentData) {
                if (studentData[serialNo] && (studentData[serialNo].isActive ===true || studentData[serialNo].isActive ===undefined) ) {
                    studentMap[serialNo] = {
                        stdName: studentData[serialNo].stdName || "",
                        stdFather: studentData[serialNo].stdFather || "",
                        stdSurname: studentData[serialNo].stdSurname || "",
                        currentClass: studentData[serialNo].currentClass || '-',
                        division: studentData[serialNo].division || '-',
                    };
                }
            }
            setStudentDataMap(studentMap);
        } catch (error) {
            console.error('Error fetching student details:', error);
        }
    };

    useEffect(() => {
        fetchRootDetails();
        fetchStudentDetails();
        fetchStudentFeeDetails();
    }, []);


    useEffect(() => {
      const fetchAllFeeDetails = async () => {
          const allFeeDetails = [];
          for (const serialNo of serialNos) {
              const feeData = await fetchFeeDetails(serialNo);
      
              if (feeData) {
                  allFeeDetails.push({
                      serialNo,
                      root: feeData.root,
                      fromtheway: feeData.fromtheway,
                      thewayup: feeData.thewayup,
                      feeData: feeData // Include other fee data (amount, etc.)
                  });
              } else {
                  allFeeDetails.push({
                      serialNo,
                      root: 'Unknown',
                      fromtheway: '-',
                      thewayup: '-',
                      feeData: { amount1: 0, fromtheway: '-', thewayup: '-' }
                  });
              }
          }
  
          // console.log("Fee Details with Roots:", allFeeDetails);
          setFeeDetails(allFeeDetails); // Store all fee details with roots
      };
  
      if (serialNos.length > 0) {
          fetchAllFeeDetails();
      }
  }, [serialNos]);
  

  const fetchStudentFeeDetails = async () => {
    try {
        const studentFeeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee.json`;
        const response = await fetch(studentFeeUrl);
        const studentFeeData = await response.json();
        console.log("Student Fee Data:", studentFeeData);

        const studentFeeMap = {};

        // Loop through each year in studentFeeData
        for (const year in studentFeeData) {
            const yearData = studentFeeData[year];

            // Loop through each serial number in the year data
            for (const serialNo in yearData) {
                const invoices = yearData[serialNo];

                // Check if invoices is an array or an object
                if (Array.isArray(invoices)) {
                    // If it's an array, loop through it
                    for (const invoice of invoices) {
                        if (invoice && invoice['Bus Fee']) {
                            // If the invoice has a Bus Fee, extract the required data
                            studentFeeMap[serialNo] = {
                                paidFee: invoice['Bus Fee'].beforePay || 0,
                                discountAmount: invoice['Bus Fee'].discountAmount || 0,
                            };
                        }
                    }
                } else {
                    // If it's an object, loop through the keys
                    let latestInvoice = null;

                    for (const invoiceNo in invoices) {
                        const invoiceData = invoices[invoiceNo];

                        if (invoiceData['Bus Fee']) {
                            // Check if this is the latest invoice
                            if (!latestInvoice || parseInt(invoiceNo) > parseInt(latestInvoice)) {
                                latestInvoice = invoiceNo;
                            }
                        }
                    }

                    // If a latest invoice is found, extract the required data
                    if (latestInvoice) {
                        const busFee = invoices[latestInvoice]['Bus Fee'];
                        studentFeeMap[serialNo] = {
                            paidFee: busFee.beforePay || 0,
                            discountAmount: busFee.discountAmount || 0,
                        };
                    }
                }
            }
        }

        setStudentFeeDataMap(studentFeeMap);
    } catch (error) {
        console.error('Error fetching student fee details:', error);
    }
};

// Function to print the content
const printContent = () => {
    const printDiv = document.getElementById('print-div');
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title> </title>');
    printWindow.document.write('<style>');
    printWindow.document.write(`
      h2, h3, h4 {
        color: #333;
      }
  
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }
          .receipt-header {
              text-align: center;
              margin-bottom: 20px;
            }
            .taludis{
              text-align: left;
            }
            
          .receipt-header h1 {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .receipt-header h2 {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .receipt-header h3 {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 20px;
            }
  
      .driver-info {
        margin: 10px 0; 
        background-color: #f2f2f2; 
        padding: 10px; 
        border-radius: 5px; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); 
      }
  
      .driver-info p {
        margin: 5px 0; 
      }
      .right-info {
        display: flex; 
        flex-direction: column; 
        align-items: flex-end; 
        margin-top: 10px; 
      }
  
      .route-info {
        display: flex; 
        align-items: center; 
      }
  
      .route-info p {
        margin: 0; 
      }
      th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
      }
  
      th {
        background-color: #f2f2f2;
        color: #333;
      }
  
      tbody tr:nth-child(even) {
        background-color: #f9f9f9;
      }
  
      tbody tr:hover {
        background-color: #f1f1f1;
      }
  
      tfoot {
        font-weight: bold;
      }
  
      tfoot td {
        background-color: #f2f2f2;
      }
    `);
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(printDiv.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };
 
    return (
<div className='main-content-of-page'>
<div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
    <button 
      onClick={handleGoBack} 
      style={{
        backgroundColor: '#FFFFFF',
        color: 'black',
        padding: '7px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginRight: '20px', // Space between buttons
        border: '1px solid black',
        marginTop: '20px',
        marginLeft: '30px',
      }}
    >
      <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
      Go Back
    </button>
<button 
onClick={() => printContent()}
    style={{
      backgroundColor: '#6495ED', /* Green background color */
      color: 'white', /* White text color */
      padding: '10px 20px', /* Add some padding to make the button larger */
      border: 'none', /* Remove the default border */
      borderRadius: '5px', /* Add a rounded corner effect */
      cursor: 'pointer' ,/* Change the cursor to a pointing hand when hovered */
      marginLeft: '10px', 
      marginTop: '20px'
    }}
  >
   Print Report
  </button>
  </div>
        <div id="print-div">



            <style>
                {`
                h2, h3, h4 {
                    color: #333;
                }
 @page {
             size: A4 Portrait;
            margin: 3mm; /* this affects the margin in the printer settings */
          }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 10px;
                }

.driver-info {
    margin: 10px 0;             /* Margin for spacing between paragraphs */
    background-color: #f2f2f2;   /* Optional: background color for better visibility */
    padding: 10px;              /* Optional: padding within driver info */
    border-radius: 5px;         /* Optional: rounded corners */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Optional: shadow for depth */
}

.driver-info p {
    margin: 5px 0;              /* Small margin between each paragraph */
}
.right-info {
    display: flex; /* Use flexbox to align the info */
    flex-direction: column; /* Stack children vertically */
    align-items: flex-end; /* Align items to the right */
    margin-top: 10px; /* Add spacing if needed */
}

.route-info {
    display: flex; /* Keep From and To on the same line */
    align-items: center; /* Center items vertically */
}

.route-info p {
    margin: 0; /* Reset margin */
}
                th, td {
                    padding: 12px;
                    text-align: left;
                    border: 1px solid #ddd;
                }

                th {
                    background-color: #f2f2f2;
                    color: #333;
                }

                tbody tr:nth-child(even) {
                    background-color: #f9f9f9;
                }

                tbody tr:hover {
                    background-color: #f1f1f1;
                }

                tfoot {
                    font-weight: bold;
                }

                tfoot td {
                    background-color: #f2f2f2;
                }
                `}
            </style>



            <div className="receipt-container">


            <div className="receipt-header" style={{border: '1px solid black', marginbottom: '10px', backgroundColor: '#F7F7F7', padding: '10px'}} >
        <h8>{schoolDetails?.sansthaName || ' '}</h8>
        <h1>{schoolDetails?.schoolName || ' '}</h1>
        <div className='taludis' style={{textAlign: 'center' }}>
 <h8>{language=== "English" ?"Taluka" : "तालुका"}: {schoolDetails?.taluka}, {language=== "English" ?"District" : "जिल्हा"}: {schoolDetails?.jilha}</h8>
</div>

        <h2 style={{
          display: 'block',
          border: '1px solid black',
          backgroundColor: 'black',
          color: 'white',
          padding: '5px',
          width: '200px',
          textAlign: 'center',
          margin: '0 auto',
          borderRadius: '10px'
        }}>{language==="English" ? "Driver Wise Report" : " चालकनिहाय अहवाल" }</h2>
         </div>
<div style={{ display: 'flex', flexDirection: 'column' , backgroundColor: '#F7F7F7', padding: '5px', border: '1px solid black',}}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0px' }}>
    <div style={{marginLeft: '20px'}}>
      <p ><strong>{language==="English" ? "Driver Name" : " चालकाचे नाव" }:</strong> {driverInfo?.driverName || ' '}</p>
    </div>
   
  </div>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ marginTop: '-15px' ,marginLeft: '20px' }}>
      <p><strong>{language==="English" ? "Address " : "पत्ता " }:</strong> {driverInfo?.address || '-'}</p>
    </div>
    <div style={{ textAlign: 'right', marginRight: '20px' }}>
      <p ><strong>{language==="English" ? "Bus No " : "बस क्र" }:</strong> {driverInfo?.busno || '-'}</p>
    </div>
  </div>
  <p style={{ marginTop: '-10px', marginLeft: '20px' }}><strong>{language==="English" ? "Phone " : "फोन" }:</strong> {driverInfo?.driverPhone || '-'}</p>
</div>
          
            <table>
                <thead>
                    <tr>
                    <th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Root" : "मार्ग"}
</th>
                    <th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Class" : "वर्ग"}
</th>
                   
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Division" : "तुकडी"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Name" : "नाव"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Fee" : "फी"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Discount (Rs)" : "सवलत (रु.)"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "After Dis Fee" : " सवलत नंतर फी"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Paid Fee" : "दिलेली फी"}
</th>
<th style={{backgroundColor:'#6495ED'}}>
  {language === "English" ? "Remaining Fee" : "उर्वरित फी"}
</th>

                    </tr>
                </thead>
                <tbody>
    {feeDetails.map(fee => {
        const studentInfo = studentDataMap[fee.serialNo] || { stdName: '-', currentClass: '-', division: '-' };
        const studentFeeInfo = studentFeeDataMap[fee.serialNo] || { paidFee: 0, discountAmount: 0 };

        const feeAmount = fee.feeData.feeAmount || 0; // Use the feeAmount obtained from Firebase
        const remainingAmount = fee['Bus Fee']?.remainingAmount || feeAmount || 0; // Get remaining amount from Bus Fee or use feeAmount
        const discountAmount = parseFloat(studentFeeInfo.discountAmount) || 0; // Ensure discountAmount is a number
        const paidFee = parseFloat(studentFeeInfo.paidFee) || 0; // Ensure paidFee is a number

        // Calculate After Discount Fee
        const AfterDisFee = remainingAmount - discountAmount;

        // Calculate Remaining Fee
        const remainingFee = AfterDisFee - paidFee;

        return (
            <tr key={fee.serialNo}>
                <td>{fee.fromtheway} to {fee.thewayup}</td>
                <td>{studentInfo.currentClass}</td>
                <td>{studentInfo.division}</td>
                <td>{`${studentInfo.stdName} ${studentInfo.stdFather || ''} ${studentInfo.stdSurname || ''}`}</td>
                <td>{feeAmount}</td>
                <td>{discountAmount}</td> {/* Display discount from studentFee */}
                <td>{AfterDisFee.toFixed(2)}</td> {/* Display After Discount Fee */}
                <td>{paidFee.toFixed(2)}</td> {/* Display paid fee from studentFee */}
                <td>{remainingFee.toFixed(2)}</td> {/* Display remaining fee */}
            </tr>
        );
    })}
</tbody>
</table>
            </div>
        </div>
        <style jsx>{`
        th{
        color: white;
        }

          td, th{
          border: 1px solid black;
          }
        `}</style>
        </div>
    );
}

export default Driverpavati;
